export default __webpack_public_path__ + "static/marketIntegration3-11ea9246e196792aec7a68dd558ca547.jpg";